import { setYear as setYearFns } from 'date-fns';

export default function setYear(date: Date, year: number): Date {
  return setYearFns(date, year);
}
